/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Maximum_10Inputs */



/**
* | output |
* | --- |
* | "Maximum: 10" |
*
* @param {Options_Backup_Maximum_10Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_maximum_10 = /** @type {((inputs?: Options_Backup_Maximum_10Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Maximum_10Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Maximum : 10")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximal: 10")
	if (locale === "it") return /** @type {LocalizedString} */ ("Massimo: 10")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимум: 10")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máximo: 10")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最多：10")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大: 10")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम: 10")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Máximo: 10")
	return /** @type {LocalizedString} */ ("Maximum: 10")
});